export default __webpack_public_path__ + "static/media/AI-society.1ca9d83d.png";